import { create } from 'zustand';

export type ToastVariant = 'success' | 'error' | 'warning' | 'info';

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface ToastOptions {
  action?: ToastAction;
  ttlMs?: number;
}

export interface Toast {
  id: string;
  variant: ToastVariant;
  message: string;
  action?: ToastAction;
}

interface ToastState {
  toasts: Toast[];
  push: (variant: ToastVariant, message: string, options?: ToastOptions) => string;
  dismiss: (id: string) => void;
}

const DEFAULT_TTL_MS = 4000;
// Action toasts stay up longer so the user has time to read + click.
const ACTION_TTL_MS = 7000;
let counter = 0;
const nextId = () => `t${++counter}`;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (variant, message, options) => {
    const id = nextId();
    set((s) => ({ toasts: [...s.toasts, { id, variant, message, action: options?.action }] }));
    const ttl =
      options?.ttlMs ??
      (options?.action ? ACTION_TTL_MS : DEFAULT_TTL_MS);
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    }, ttl);
    return id;
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));
